import React from 'react';
import SelectItem from './Select';
import DateItem from './Date';
import NumberItem from './Number';
import TextItem from './Text';
import {CustomizeItemContext} from '../CustomizeItemContext';

const Item = () => {
  const {poolProspectCustomizeItem} = React.useContext(CustomizeItemContext);

  if (poolProspectCustomizeItem?.dataType === 'select') {
    return <SelectItem />;
  }
  if (poolProspectCustomizeItem?.dataType === 'date') {
    return <DateItem />;
  }
  if (poolProspectCustomizeItem?.dataType === 'number') {
    return <NumberItem />;
  }
  if (poolProspectCustomizeItem?.dataType === 'text') {
    return <TextItem />;
  }
  return <></>;
};
export default Item;
